@switch (breakSvc.breakPointDevice()) {
@default {
<div class="auth-mobile-page-container ps-h-100 ps-d-flex ps-flex-column">
  <div class="ps-w-100 ps-d-flex ps-flex-wrap">

    <div class="authentication-title-container ps-w-100">
      <p purpleEditableText tranKey='login_page_title' class="auth-form-title">
        {{ T.LOGIN.page_title | translation: [] }}
      </p>
      <p purpleEditableText tranKey='login_page_subtitle' class="auth-form-subtitle">
        {{ T.LOGIN.page_subtitle | translation: [] }}
      </p>
    </div>

    <div class="selected-company-container">

      <div class="company-info-wrapper ps-d-flex ps-align-items-center">
        <div class="purple-fit-mobile-logo" contentId="purple-fit-logo" contentTypeId="auth-page" purpleEditableImage>
        </div>

        <div class="company-text-info">
          <p purpleEditableText tranKey='login_page_selected_company' class="selected-company-title">
            {{ T.LOGIN.page_selected_company | translation: [] }}
          </p>
          <p class="selected-company-name">
            <strong>{{ selectedCompany }}</strong>
          </p>
        </div>
      </div>

      <button class="change-company" (click)="changeCompany()" nz-button nzType="primary">
        <span class="icon-sync"></span>
        <!-- <span>{{ T.MY_PURPLE_FIT.change_company | translation }}</span> -->
      </button>

    </div>

    @if(purpleFormFieldGroups!= undefined){
    <purple-form [disabledForm]="isLoading" class="ps-w-100" [(formGroup)]="validateForm"
      [purpleFormFieldGroups]="purpleFormFieldGroups" (purpleFormSubmit)="login()">
    </purple-form>
    }

    <div class="other-info-container ps-w-100 ps-d-flex ps-justify-content-between">
      <label purpleEditableText tranKey='login_page_remember_me' class="remember-me" nz-checkbox
        [(ngModel)]="rememberCheck">{{ T.login_page_remember_me | translation}}</label>
      <a purpleEditableText tranKey='login_page_forgot_password'
        [href]="[((tsvc.currentLanguage())??'') + '/request-reset-password']" class="forgot-password">
        {{ T.LOGIN.page_forgot_password | translation: [] }}
      </a>
    </div>

  </div>

  <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-mt-auto">
    <div purpleEditableText tranKey='login_page_register_disclaim' class="register-disclaim ps-w-100" [innerHTML]="T.login_page_register_disclaim | translation: 
        [((tsvc.currentLanguage())??'')+'/register']">
    </div>

    <purple-simple-button (click)="login()" class="ps-w-100" purpleEditableText tranKey='login_page_login_button'
      [isLoading]="isLoading" [isDisabled]="isLoading" [buttonText]="T.LOGIN.page_login_button | translation: []"
      [buttonType]="'primary'">
    </purple-simple-button>

    <div class="line-other-login-container ps-w-100">
      <div class="other-login-line"></div>
      <p purpleEditableText tranKey='login_page_other_login' #logintext class="other-login-text">
        {{ T.LOGIN.page_other_login | translation: [] }}</p>
      <div class="other-login-line"></div>
    </div>

    <div class="other-login-container ps-w-100 ps-d-flex ps-justify-content-between">
      <button (click)="loginWithSocial('google')" class="other-login-button" nz-button nzType="default">
        <img src="/assets/social-icons/google_logo.png" class="login-social-logo">
        <span purpleEditableText tranKey='login_page_login_with_google' class="login-button-text">{{
          T.login_page_login_with_google | translation}}</span>
      </button>
      <button (click)="loginWithSocial('apple')" class="other-login-button" nz-button nzType="default">
        <img src="/assets/social-icons/apple_logo.png" class="login-social-logo">
        <span purpleEditableText tranKey='login_page_login_with_apple' class="login-button-text">{{
          T.login_page_login_with_apple | translation}}</span>
      </button>
    </div>
  </div>
</div>
}
@case ("desktop") {
<div class="desktop-page-external-container">
  <div class="desktop-page-container">
    <div class="ps-w-100 ps-d-flex ps-flex-wrap auth-container">
      <!-- <img contentId="logo-authentication-header" contentTypeId="logo" purpleEditableImage
            class="authentication-logo"> -->
    <div class="auth-container-form-container">
      <div class="auth-form-container auth-login-form-container">
        <p purpleEditableText tranKey='login_page_desktop_form_title' class="auth-form-title">
          {{ T.LOGIN.page_desktop_form_title | translation: [] }}
        </p>
        <p class="auth-form-subtitle" purpleEditableText tranKey='login_page_desktop_form_subtitle'>
          {{ T.LOGIN.page_desktop_form_subtitle | translation: [] }}
        </p>
        <button (click)="loginWithSocial('google')" class="other-login-button">
          <img src="/assets/social-icons/google_logo.png" class="login-social-logo">
          <p purpleEditableText tranKey='login_page_login_with_google' class="login-button-text">{{
            T.login_page_login_with_google | translation}}
          </p>
        </button>
        <button (click)="loginWithSocial('apple')" class="other-login-button ps-mt-3">
          <img src="/assets/social-icons/apple_logo.png" class="login-social-logo">
          <p purpleEditableText tranKey='login_page_login_with_apple' class="login-button-text">{{
            T.login_page_login_with_apple | translation}}
          </p>
        </button>
        <div class="line-other-login-container">
          <div class="other-login-line"></div>
          <p purpleEditableText tranKey='login_page_other_login' #logintext class="other-login-text">{{
            T.login_page_other_login | translation}}</p>
          <div class="other-login-line"></div>
        </div>
        @if(purpleFormFieldGroups!= undefined){
        <purple-form [disabledForm]="isLoading" class="ps-w-100" [(formGroup)]="validateForm"
          [purpleFormFieldGroups]="purpleFormFieldGroups" (purpleFormSubmit)="login()">
        </purple-form>
        }
        <div class="other-info-container">
          <label purpleEditableText tranKey='login_page_remember_me' class="remember-me" nz-checkbox
            [(ngModel)]="rememberCheck">{{ T.login_page_remember_me | translation}}</label>
          <a purpleEditableText tranKey='login_page_forgot_password'
            [href]="[((tsvc.currentLanguage())??'') + '/request-reset-password']" class="forgot-password">
            {{ T.LOGIN.page_forgot_password | translation: [] }}
          </a>
        </div>
        <purple-simple-button (click)="login()" purpleEditableText tranKey='login_page_login_button'
          [isLoading]="isLoading" [isDisabled]="isLoading" [buttonText]="T.LOGIN.page_login_button | translation: []"
          [buttonType]="'primary'">

        </purple-simple-button>

        <div class="register-disclaim" purpleEditableText tranKey='login_page_register_disclaim' [innerHTML]="T.login_page_register_disclaim | translation: 
                [((tsvc.currentLanguage())??'')+'/register']"></div>

        <!-- <button class="change-company" (click)="changeCompany()" nz-button nzType="primary">
          <span class="icon-sync"></span>
          <p>{{ T.MY_PURPLE_FIT.change_company | translation }}</p>
        </button> -->
      </div>


    </div>
    <div contentId="authentication-img" contentTypeId="auth-page" purpleEditableImage class="auth-container-img">
      <!-- <div class="auth-container-img"> -->
      <div class="black-overlay">
      </div>
      <div class="text-overlay">
        <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-justify-content-center">
          <!-- <p purpleEditableText tranKey='auth_page_purple-fit_name' class="purple-fit-text">{{ T.AUTH_PAGE.purple_fit_name | translation: [] }}</p> -->

          <div class="purple-fit-text-logo" contentId="purple-fit-logo" contentTypeId="auth-page" purpleEditableImage>
          </div>

          <p purpleEditableText tranKey='auth_page_promo_disclaimer' class="purple-fit-promo-text">
            {{ T.AUTH_PAGE.promo_disclaimer | translation: [] }}
          </p>
        </div>
      </div>
    </div>

  </div>

  </div>
</div>
}
}